import SelectDisplay from './SelectDisplay';

export default SelectDisplay;